import axios from 'axios'

const contentUrl = process.env.VUE_APP_CONTENT_URL

const fetchTranslations = (language, type) => axios
  .get(`${contentUrl}translations?language=${language}&type=${type}`)
  .then(response => {
    let translation = {}
    translation[language] = response.data
    return translation
  }, error => {
    return { errorCode: error.response.status }
  })

export default {
  fetchTranslations
}
